/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wc_characters_no_spaces = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Characters (no spaces)`)
};

const es_wc_characters_no_spaces = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres (sin espacios)`)
};

const de_wc_characters_no_spaces = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeichen (ohne Leerzeichen)`)
};

const nl_wc_characters_no_spaces = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekens (zonder spaties)`)
};

const fr_wc_characters_no_spaces = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caractères (sans espaces)`)
};

const it_wc_characters_no_spaces = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caratteri (senza spazi)`)
};

const pt_br2_wc_characters_no_spaces = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres (sem espaços)`)
};

const pt_wc_characters_no_spaces = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres (sem espaços)`)
};

const ja_wc_characters_no_spaces = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字（スペースなし）`)
};

const zh_wc_characters_no_spaces = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字符数（不含空格）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wc_characters_no_spaces = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wc_characters_no_spaces(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wc_characters_no_spaces", locale)
	if (locale === "en") return en_wc_characters_no_spaces(inputs)
	if (locale === "es") return es_wc_characters_no_spaces(inputs)
	if (locale === "de") return de_wc_characters_no_spaces(inputs)
	if (locale === "nl") return nl_wc_characters_no_spaces(inputs)
	if (locale === "fr") return fr_wc_characters_no_spaces(inputs)
	if (locale === "it") return it_wc_characters_no_spaces(inputs)
	if (locale === "pt-BR") return pt_br2_wc_characters_no_spaces(inputs)
	if (locale === "pt") return pt_wc_characters_no_spaces(inputs)
	if (locale === "ja") return ja_wc_characters_no_spaces(inputs)
	return zh_wc_characters_no_spaces(inputs)
};